import { render, staticRenderFns } from "./InventarioCompilado.vue?vue&type=template&id=2ef9aec6&scoped=true"
import script from "./InventarioCompilado.vue?vue&type=script&lang=js"
export * from "./InventarioCompilado.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=2ef9aec6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef9aec6",
  null
  
)

export default component.exports